module.exports = __webpack_public_path__ + "static/media/Green-icon.3df70631.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start/Green-icon.svg
// module id = 1138
// module chunks = 0